import { render, staticRenderFns } from "./BuildingEditDatesTab.vue?vue&type=template&id=c25ff096"
import script from "./BuildingEditDatesTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditDatesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports